/**
 * Created by Andrey Popov on 04.09.20
 */

const JackpotCard = function (options) {
    Card.call(this, options);

    this.feature = "jackpot";
};

JackpotCard.prototype = Object.create(Card.prototype);
JackpotCard.constructor = JackpotCard;

JackpotCard.prototype.getViewClass = function () {
    return JackpotCardView;
};

JackpotCard.prototype.getSkin = function () {
    return "jackpot";
};

JackpotCard.prototype.canPlay = function () {
    return false;
};

JackpotCard.prototype.canBeAttacked = function () {
    return false;
};

JackpotCard.prototype.autoPlay = function () {
    let extraPart = Math.ceil(20 * Math.random());
    extraPart -= extraPart % 10;
    const prize = {
        "hard": 10 + extraPart
    };
    const reward = cleverapps.user.prepareRewardByRich(prize, 5).hard;

    this.trigger("win", reward);

    Game.currentGame.counter.setTimeout(() => {
        Game.currentGame.table.removeCard(this);
        Game.currentGame.log.clear();

        Game.currentGame.addHardReward(reward);
    }, 1800);
};

JackpotCard.isAvailable = function () {
    if (cleverapps.flags.monetization !== cleverapps.Flags.MONETIZATION_REGULAR || cleverapps.config.editorMode) {
        return false;
    }

    const lastAppearTime = cleverapps.dataLoader.localStorage.getItem(DataLoader.TYPES.JACKPOT_LAST_APPEAR_TIME);
    if (lastAppearTime && parseInt(lastAppearTime) + JackpotCard.APPEAR_TIMEOUT > Date.now()) {
        return false;
    }

    return cleverapps.user.checkAvailable(cleverapps.config.availables.JACKPOT_CARD);
};

JackpotCard.APPEAR_TIMEOUT = cleverapps.parseInterval("1 hour");